var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector14(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 554,
    viewBox: "0 0 430 554",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M648.797 61.6246C619.304 46.038 588.326 33.4412 556.328 24.0225C502.815 8.18785 446.959 0.923588 390.799 0.792909C202.44 0.399226 10.5982 80.3505 -108.34 186.536C-123.884 200.36 -138.554 215.136 -152.266 230.78C-166.498 246.948 -179.326 264.301 -190.611 282.649C-204.572 305.577 -215.709 330.374 -222.013 356.456C-232.512 399.922 -227.692 439.198 -212.262 470.7C-204.039 487.568 -192.464 502.585 -178.245 514.832C-164.026 527.078 -147.461 536.299 -129.561 541.93C-105.154 549.738 -77.7403 551.42 -48.9805 545.507C-34.0308 542.6 -19.5236 537.759 -5.82415 531.107C96.7441 480.159 29.9394 372.163 127.844 332.503C248.58 283.549 320.812 476.577 416.406 522.875C468.723 548.214 530.616 566.725 621.533 540.328C626.19 538.98 630.775 537.512 635.29 535.923C700.053 513.214 737.974 478.333 766.047 438.664C793.066 400.383 807.52 354.647 807.412 307.782C807.521 264.651 796.014 220.702 773.293 180.428C757.55 152.686 737.35 127.723 713.503 106.539C693.828 89.0072 672.101 73.9255 648.797 61.6246Z",
    fill: "url(#paint0_linear_1_3755)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3755",
    x1: 416.855,
    y1: 744.428,
    x2: 395.861,
    y2: 250.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B67CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DC3EE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector14);
export default __webpack_public_path__ + "static/media/vector14.066cb53226ae2e17afb66226354c6e70.svg";
export { ForwardRef as ReactComponent };